import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-with-text',
  templateUrl: './image-with-text.component.html',
  styleUrls: ['./image-with-text.component.css'],
})
export class ImageWithTextComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
